module.exports = "/_next/static/images/logo-JSWA-9913f6813791a11da054f88457d4712c.png";